import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ConfService} from '../../conf.service';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {AppComponent} from '../../app.component';
import {Router} from '@angular/router';

@Component({
  selector: 'ap-test-results',
  templateUrl: './test-results.component.html',
  styleUrls: ['./test-results.component.scss']
})
export class TestResultsComponent implements OnInit {
  testSuiteResponse: any;
  reportName: string;

  componentLoading = true;
  @Input() resultsData: any;
  isError = false;

  currentActiveIndex = 0;
  tabChangeLoading = false;

  constructor(public platform: LeftpanelComponent, private router: Router, public appComp: AppComponent) { }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }
    if (this.resultsData) {
      if (this.resultsData.length === 0) {
        this.isError = true;
      }
      // else {
      //   this.reportName = this.resultsData[0]['name'] + '(' + this.resultsData[0]['version'] + ')';
      //   this.testSuiteResponse = JSON.parse(this.resultsData[0]['response']['body']);
      // }
      this.componentLoading = false;
    }
  }

  setResult(id, i) {
    // const index = this.resultsData.findIndex(value => value['name'] === reportName && value['timestamp'] === timestamp);
    // this.testSuiteResponse = JSON.parse(this.resultsData[index]['response']['body']);
    // this.reportName = this.resultsData[index]['name'] + '(' + this.resultsData[index]['version'] + ')';
    this.currentActiveIndex = i;
    this.tabChangeLoading = true;
    setTimeout(() => {
      this.tabChangeLoading = false;
    }, 100);
  }

  getParsedJSON(jsonstr) {
    return JSON.parse(jsonstr);
  }

  getDataAndTime(timeStamp) {
    if (timeStamp) {
      const date_ob = new Date(timeStamp);
      let hours = date_ob.getHours();
      const minutes = ('0' + date_ob.getMinutes()).slice(-2);
      const seconds = ('0' + date_ob.getSeconds()).slice(-2);
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12;


      return (date_ob.toDateString()) + ' ' + hours + ':' + minutes + ':' + seconds + ' ' + ampm;
    } else {
      return '-';
    }
  }

  hasViewPagePermissions() {
    return this.platform.hasPlatformPermission('VIEW_TEST_RESULTS');
  }
}
